import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, fade } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import moment from '../../helpers/dates';
import config from './config';

const useStyles = makeStyles((theme) => ({
  photoGroup: {
    all: 'unset',
    width: '100%',
    position: 'relative',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    boxShadow: '0 4px 4px rgba(0, 0, 0, 0.25)',
  },
  disabled: {
    filter: 'grayscale(100%)',
    '& $backdrop': {
      backgroundColor: 'transparent',
    },
  },
  grayscale: {
    filter: 'grayscale(100%)',
  },
  mainText: {
    color: 'inherit',
    fontSize: 70,
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      fontSize: 60,
    },
  },
  topText: {
    color: 'inherit',
    fontSize: 25,
    fontWeight: 400,
    marginBottom: theme.spacing(-2),
  },
  bottomText: {
    color: 'inherit',
    fontSize: 25,
    fontWeight: 400,
    marginTop: theme.spacing(-2),
  },
  backdrop: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: fade(theme.palette.primary.main, 0.5),
    color: theme.palette.common.white,
  },
}));

const PhotoGroupCover = ({
  topText,
  mainText,
  bottomText,
  group,
  height,
  setCurrentPhotoGroup,
  link,
  grayscale,
}) => {
  const classes = useStyles();
  const disabled = moment().isBefore(config[group]?.enableFrom);
  const clickable = !!link || (!!setCurrentPhotoGroup && !disabled);

  return (
    <button
      className={clsx(
        classes.photoGroup,
        disabled && classes.disabled,
        grayscale && classes.grayscale
      )}
      style={{
        height,
        backgroundImage: disabled ? `linear-gradient(rgba(0, 0, 0, 0.65),rgba(0, 0, 0, 0.65)), url(${config[group]?.cover})` : `url(${config[group]?.cover})`,
        cursor: clickable ? 'pointer' : 'auto',
      }}
      onClick={() => {
        if (link) {
          window.open(link, '_blank', 'noopener,noreferrer');
          return;
        }
        if (setCurrentPhotoGroup) setCurrentPhotoGroup(group);
      }}
      disabled={(!setCurrentPhotoGroup && !link) || disabled}
      type="button"
    >
      <div className={classes.backdrop}>
        {!!topText && (
          <Typography className={classes.topText} variant="subtitle1">
            {topText}
          </Typography>
        )}
        <Typography className={classes.mainText} variant="h1">
          {mainText}
        </Typography>
        {!!bottomText && (
          <Typography className={classes.bottomText} variant="subtitle1">
            {bottomText}
          </Typography>
        )}
      </div>
    </button>
  );
};

PhotoGroupCover.propTypes = {
  topText: PropTypes.string,
  mainText: PropTypes.string.isRequired,
  bottomText: PropTypes.string,
  group: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  setCurrentPhotoGroup: PropTypes.func,
  link: PropTypes.string,
  grayscale: PropTypes.bool,
};

PhotoGroupCover.defaultProps = {
  topText: undefined,
  bottomText: undefined,
  setCurrentPhotoGroup: undefined,
  link: undefined,
  grayscale: false,
};

export default PhotoGroupCover;
